module.exports = __webpack_public_path__ + "media/images/country_flags/uy-627a06d8003d758bd204db389faa5c6d.png";